__turbopack_context__.v({
  "active": "select-module-scss-module__FDn0aa__active",
  "disabled": "select-module-scss-module__FDn0aa__disabled",
  "dropdownArrow": "select-module-scss-module__FDn0aa__dropdownArrow",
  "empty": "select-module-scss-module__FDn0aa__empty",
  "error": "select-module-scss-module__FDn0aa__error",
  "focused": "select-module-scss-module__FDn0aa__focused",
  "gray": "select-module-scss-module__FDn0aa__gray",
  "label": "select-module-scss-module__FDn0aa__label",
  "lightBlue": "select-module-scss-module__FDn0aa__lightBlue",
  "noBorder": "select-module-scss-module__FDn0aa__noBorder",
  "pink": "select-module-scss-module__FDn0aa__pink",
  "rotate": "select-module-scss-module__FDn0aa__rotate",
  "searchInput": "select-module-scss-module__FDn0aa__searchInput",
  "select": "select-module-scss-module__FDn0aa__select",
  "selectBtn": "select-module-scss-module__FDn0aa__selectBtn",
  "selectContent": "select-module-scss-module__FDn0aa__selectContent",
  "selectItem": "select-module-scss-module__FDn0aa__selectItem",
  "skuLabel": "select-module-scss-module__FDn0aa__skuLabel",
  "text": "select-module-scss-module__FDn0aa__text",
  "top": "select-module-scss-module__FDn0aa__top",
  "transparent": "select-module-scss-module__FDn0aa__transparent",
  "visible": "select-module-scss-module__FDn0aa__visible",
  "white": "select-module-scss-module__FDn0aa__white",
  "withoutBorder": "select-module-scss-module__FDn0aa__withoutBorder",
});
